import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=c027c31a&scoped=true"
import script from "./TransactionList.vue?vue&type=script&lang=js"
export * from "./TransactionList.vue?vue&type=script&lang=js"
import style0 from "./TransactionList.vue?vue&type=style&index=0&id=c027c31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c027c31a",
  null
  
)

export default component.exports